export default __webpack_public_path__ + "static/media/shlomi-shabat_bereshit-olam.f5ccc181.mp3";